export default __webpack_public_path__ + "static/media/default.a27a09f233518ccf0127383449c92c0c.svg";